export default __webpack_public_path__ + "static/media/shopee1.101be5bf.png";